import { createFlexPrimitive } from './createFlexPrimitive.tsx';

const Inline = createFlexPrimitive({
  direction: 'row',
  defaultAlign: 'center',
  defaultJustify: 'start',
  defaultWrap: true,
});

Inline.displayName = 'Inline';

export { Inline };
